import { render, staticRenderFns } from "./IndividualSignup.vue?vue&type=template&id=0804f452&scoped=true"
import script from "./IndividualSignup.vue?vue&type=script&lang=js"
export * from "./IndividualSignup.vue?vue&type=script&lang=js"
import style0 from "./IndividualSignup.vue?vue&type=style&index=0&id=0804f452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0804f452",
  null
  
)

export default component.exports